import type { ReactNode } from 'react';
import styles from './page-heading.module.css';

export interface PageHeadingProps {
  title: string;
  description?: string;
  /** Primary and secondary actions, right-aligned. One primary button at most. */
  actions?: ReactNode;
  /** Breadcrumb or back link rendered above the title. */
  above?: ReactNode;
  /** Tabs, segmented control or filters rendered below the title row. */
  below?: ReactNode;
}

/** One heading per page, sentence case, with the page's single primary action beside it. */
export function PageHeading({ title, description, actions, above, below }: PageHeadingProps) {
  return (
    <header className={styles.root}>
      {above ? <div className={styles.above}>{above}</div> : null}
      <div className={styles.row}>
        <div className={styles.text}>
          <h1 className={styles.title}>{title}</h1>
          {description ? <p className={styles.description}>{description}</p> : null}
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
      {below ? <div className={styles.below}>{below}</div> : null}
    </header>
  );
}
